import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { BREAKPOINTS } from '../../../../styles/constants'
import { NotinoLabelLarge, NotinoLabelRegular400, NotinoTitleMedium, resetButtonStyles } from '../../../../styles/helpers'

export const ModalContent = styled.div`
	padding: 20px;
	height: 100%;

	@media (min-width: ${BREAKPOINTS.sm}) {
		height: auto;
	}
`

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;

	@media (min-width: ${BREAKPOINTS.sm}) {
		height: auto;
	}
`

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 20px;
`

export const HeaderTitle = styled.div`
	${NotinoTitleMedium};
`

export const CloseButton = styled.button`
	${resetButtonStyles};
`

export const Main = styled.main`
	display: flex;
	flex-direction: column;
	gap: 24px;
	margin-bottom: 40px;
	flex: 1;
`

export const Footer = styled.footer`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: auto;
	position: sticky;
	bottom: 0;
	margin: auto -20px -20px -20px;
	background: ${theme.color.background.primary};
	padding: 20px;
`

export const Description = styled.p`
	color: ${theme.color.text.secondary};
	${NotinoLabelRegular400};
	margin-bottom: 20px;
`

export const FeedbackAnswersLabel = styled.span`
	${NotinoLabelLarge};
	display: inline-flex;
	align-items: center;
	min-height: 36px;
`
